import { useState, useEffect } from "react";
import { Select, Text } from "@mantine/core";
import { Modal, Group } from "@mantine/core";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Button from "../../../components/Button";
import { backendUrl } from "../../../constants";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";

const NewEducation = ({
  opened,
  setOpened,
  setRefetch,
  documentData,
  editId,
  editData,
}) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [documentType, setDocumentType] = useState([]);
  const [files, setFiles] = useState([]);
  const [document, setDocument] = useState({ userId: createdBy.id });

  //state
  useEffect(() => {
    if (editData) {
      console.log("editDtaa", editData);
      form.setFieldValue("documentType", editData?.documentType._id);
      form.setFieldValue("documentName", editData?.documentName);
      setFiles([editData.document]);
    }
  }, [editData]);
  //document type
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/documentType`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setDocumentType((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      documentType: "",
      documentName: "",
    },

    validate: {
      documentType: (value) =>
        value?.length < 1 ? "Please Select File Type" : null,
      documentName: (value) =>
        value?.length < 1 ? "Please Type File Name" : null,
    },
  });

  const handleDocument = (values) => {
    let formData = new FormData();
    Object.keys(values).forEach((key) => formData.append(key, values[key]));
    formData.append("userId", createdBy.id);

    if (files.length < 1) {
      showNotification({
        message: "Please Upload File",
        color: "red",
      });
      return;
    } else {
      formData.append("document", files[0]);
      const options = {
        method: "POST",
        headers: {
          Accept: "application/form-data",
        },
        body: formData,
      };
      if (editData) {
        formData.append("documentId", editData._id);
        fetch(`${backendUrl}user/editJobSeekerDocuments`, options)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              showNotification({
                message: "Document Edited",
                color: "green",
              });
            } else {
              showNotification({
                message: response.message,
                color: "red",
              });
            }
          })
          .catch((err) => console.error(err));
      } else {
        fetch(`${backendUrl}user/saveJobSeekerDocuments`, options)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              showNotification({
                message: "New Document Added",
                color: "green",
              });
              setRefetch((v) => !v);
            } else {
              showNotification({
                message: response.message,
                color: "red",
              });
            }
          })
          .catch((err) => console.error(err));
      }
      handleClose();
    }
  };

  const handleClose = () => {
    setOpened(false);
    setFiles([]);
    form.reset();
  };

  return (
    <>
      <Modal
        opened={opened}
        centered
        onClose={handleClose}
        title="Add New Document"
      >
        <form
          className="new-education"
          onSubmit={form.onSubmit((values) => handleDocument(values))}
        >
          <p style={{ margin: "0px", fontWeight: "500" }}>File Type</p>
          <Select
            placeholder="File Type"
            data={documentType}
            searchable
            {...form.getInputProps("documentType")}
            maxDropdownHeight={400}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>File Name</p>
          <InputField
            placeholder="File Name"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            validateName="documentName"
            form={form}
          />
          <div>
            {files.length > 0 && <p>{files[0]?.name}</p>}
            <Dropzone
              accept={MIME_TYPES.pdf}
              // onDrop={setFiles}
              multiple={false}
              maxFiles={1}
              onDrop={(v) => {
                setFiles(v);
                setDocument((document) => ({
                  ...document,
                  document: v[0],
                }));
              }}
              // style={{ width: "220px" }}
            >
              <Text align="center">Upload PDF</Text>
            </Dropzone>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button title="Cancel" onClick={handleClose} />
            <Button title="Add Document" primary={true} type="submit" />
          </div>
        </form>
      </Modal>
    </>
  );
};
export default withTranslation()(NewEducation);
